import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from '../../utils/forms';

const propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string.isRequired,
  maxLength: PropTypes.string,
  minLength: PropTypes.string,
  autoFocus: PropTypes.bool,
  checked: PropTypes.bool,
  meta: PropTypes.object.isRequired,
  touched: PropTypes.bool,
  error: PropTypes.bool,
};

const defaultProps = {
  placeholder: '',
  maxLength: null,
  minLength: null,
  autoFocus: false,
  checked: false,
  touched: false,
  error: false,
};

const InputField = ({
  input,
  label,
  placeholder,
  type,
  maxLength,
  minLength,
  autoFocus,
  checked,
  meta: { touched, error },
}) => (
  <div className={getClassName(touched, error)}>
    <label htmlFor={input.id} className="form-control-label">
      {label} {touched && error && <span className="error">| {error}</span>}
    </label>
    <input
      {...input}
      className="form-control form-control-success"
      placeholder={placeholder}
      type={type}
      maxLength={maxLength}
      minLength={minLength}
      autoFocus={autoFocus}
      checked={checked}
    />
  </div>
);

InputField.propTypes = propTypes;
InputField.defaultProps = defaultProps;

export default InputField;
